export enum AdvertisementType {
  HOME_MAIN = 'homeMain',
  HOME_RECOMMENDATION = 'homeRecommendation',
  HOME_RECENT = 'homeRecent',
  CATEGORY_MAIN = 'categoryMain'
}

export interface Advertisement {
  id: number;
  title: string;
  brief: string;
  description: string;
  image_url: string | null;
  web_url: string | null;
  type: AdvertisementType;
  is_active: boolean;
  category_id: number | null;
  store_id: number | null;
  product_id: number | null;
  created_at?: string;
  updated_at?: string;
  available_from?: string | null;
  available_to?: string | null;
  category?: {
    id: number;
    category_name: string;
  };
  store?: {
    id: number;
    name: string;
  };
  product?: {
    id: number;
    product_name: string;
  };
}

export interface CreateAdvertisementPayload {
  title: string;
  brief: string;
  description: string;
  image_url?: string | null;
  web_url?: string | null;
  type: AdvertisementType;
  is_active?: boolean;
  category_id?: number | null;
  store_id?: number | null;
  product_id?: number | null;
  available_from?: string | null;
  available_to?: string | null;
}

export interface UpdateAdvertisementPayload extends Partial<CreateAdvertisementPayload> {}
